import React from 'react';
export default function SpaceHelmetSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="visorReflect" cx="0.3" cy="0.3" r="0.7">
          <stop offset="0%" stopColor="#B3E5FC" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#0288D1" stopOpacity="0.3" />
        </radialGradient>
      </defs>

      {/* Outer dome - silver frame */}
      <ellipse cx="20" cy="22" rx="17" ry="16" fill="#B0BEC5" />
      <ellipse cx="20" cy="22" rx="16" ry="15" fill="#CFD8DC" />

      {/* Glass dome */}
      <ellipse cx="20" cy="20" rx="13" ry="12" fill="#263238" />
      <ellipse cx="20" cy="20" rx="13" ry="12" fill="url(#visorReflect)" />

      {/* Reflective highlight arc */}
      <path d="M12 14 C14 10 20 8 26 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
      <path d="M10 18 C11 16 13 14 16 13" stroke="white" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.3" />

      {/* Collar ring */}
      <ellipse cx="20" cy="34" rx="14" ry="4" fill="#90A4AE" />
      <ellipse cx="20" cy="33" rx="13" ry="3" fill="#B0BEC5" />

      {/* Side bolts */}
      <circle cx="5" cy="24" r="2" fill="#78909C" />
      <circle cx="5" cy="24" r="1" fill="#546E7A" />
      <circle cx="35" cy="24" r="2" fill="#78909C" />
      <circle cx="35" cy="24" r="1" fill="#546E7A" />

      {/* Antenna */}
      <line x1="20" y1="6" x2="20" y2="2" stroke="#90A4AE" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="20" cy="1.5" r="1.5" fill="#EF5350" />
      <circle cx="20" cy="1.5" r="0.8" fill="#FF8A80">
        <animate attributeName="opacity" values="0.5;1;0.5" dur="1.5s" repeatCount="indefinite" />
      </circle>

      {/* Small star reflection on glass */}
      <circle cx="14" cy="16" r="0.6" fill="white" opacity="0.6" />
      <circle cx="24" cy="22" r="0.4" fill="white" opacity="0.4" />
    </svg>
  );
}
